<template>
    <div class="bank_title">
        <div class="bank_content">
            <div class="title_l">
                <div class="goback">
                    <img v-if="data.isShow" src="../assets/goback.png" alt="">
                    <span></span>
                </div>
                <div class="model">
                    <!-- <div class="model_item" :class="{ current_nav_l: activeNav === 'operateIndex' }" @click="go(1)">
                        综合概览
                    </div>
                    <div class="model_item" :class="{ current_nav_l: activeNav === 'breederIndex' }" @click="go(6)">
                        养殖户分析
                    </div>
                    <div class="model_item" :class="{ current_nav_l: activeNav === 'livestock' }" @click="go(7)">
                        活畜分析
                    </div>
                    <div class="model_item" :class="{ current_nav_l: activeNav === 'transactionIndex' }" @click="go(5)">
                        产业电商
                    </div>
                    <div class="model_item" :class="{ current_nav_l: activeNav === 'financialIndex' }" @click="go(3)">
                        金融服务
                    </div> -->
                </div>
            </div>
            <!-- <span class="title_name">{{ data.name }}</span> -->
            <span class="title_name">阿尔善宝拉格镇巴彦高勒嘎查</span>
            <div class="title_r">
                <div class="model">
                    <!-- <div class="model_item" @click="go()">
                        活畜分布
                    </div>
                    <div class="model_item" @click="go()">
                        繁育分析
                    </div> -->
                    <!-- <div class="model_item" :class="{ current_nav: activeNav === 'slaughter' }" @click="go(8)">
                        屠宰加工
                    </div>
                    <div class="model_item" :class="{ current_nav: activeNav === 'traceIndex' }" @click="go(2)">
                        商品溯源
                    </div> -->
                    <!-- <div class="model_item" :class="{ current_nav: activeNav === 'empty_3' }" @click="go(9)">
                        畜牧科技师
                    </div>
                    <div class="model_item" :class="{ current_nav: activeNav === 'empty' }" @click="go()">
                        区域合伙人
                    </div> -->
                    <!-- <div v-if="myKey" class="model_item" :class="{ current_nav: activeNav === 'general' }" @click="go(6)">
                        综合概览
                    </div> -->
                </div>
                <div class="time">
                    <span @click="exitLogin">退出</span>
                    <!-- <label>{{time}}</label> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { parseTime } from '@/utils/format.js'
export default {

    data() {
        return {
            time: parseTime(new Date(), 'yyyy-MM-dd HH:mm:ss'),
            userName: '',
            login: ''
            // myKey: '' || window.localStorage.getItem('MYKEY')
        };
    },
    props: {
        data: Object
    },
    created() {
        // this.myKey = this.$route.params.myKey
        // window.localStorage.setItem('MYKEY',this.muKey)
        // console.log(this.myKey,666);
        this.activeNav = this.$route.meta.activeNav
        this.time = parseTime(new Date(), 'yyyy-MM-dd HH:mm:ss')
        setInterval(() => {
            this.time = parseTime(new Date(), 'yyyy-MM-dd HH:mm:ss')
        }, 1000)
        this.userName = window.localStorage.getItem('NMYDATAAUSERNAME')
        this.login = window.localStorage.getItem('LOGIN')
        // console.log( this.login,'this.login');
    },
    watch: {},
    methods: {
        exitLogin() {
            this.$router.push({ path: '/ablogin' })
            window.localStorage.removeItem('mapfileUrl')
            window.localStorage.removeItem('NMYDATAUSERINFO')
            window.localStorage.removeItem('NMYDATAASSTSTOKEN')
            window.localStorage.removeItem('LOGIN')
            // this.$router.push({ path: '/login' })
        },
        goback() {
            this.$router.go(-1)
        },
        go(type) {
            switch (type) {
                case 1:
                    this.$router.push({ name: 'operate' })
                    break;
                case 2:
                    this.$router.push({ name: 'traceIndex' })
                    break;
                case 3:
                    this.$router.push({ name: 'financial' })
                    break;
                case 4:
                    this.$router.push({ name: 'user' })
                    break;
                case 5:
                    this.$router.push({ name: 'transaction' })
                    break;
                case 6:
                    this.$router.push({ name: 'breeder' })
                    break;
                case 7:
                    this.$router.push({ name: 'livestock' })
                    break;
                case 8:
                    this.$router.push({ name: 'slaughter' })
                    break;
                case 9:
                    this.$router.push({ name: 'empty_3' })
                    break;
                default:
                    this.$router.push({ name: 'empty' })
            }
        }

    },
};
</script>
<style lang="scss" scoped>
.main {
    width: 100%;

    .bank_title {
        background: #020e2a;

        .bank_content {
            height: 1rem;
            // background-image: url("../assets/data_title_bg.png");
            background-size: 100% 100%;
            display: flex;
            justify-content: space-between;
            // align-items: center;

            .title_name {
                display: block;
                flex: 1;
                // height: 1rem;
                // padding-bottom: 0.24rem;
                line-height: .9rem;
                text-align: center;
                background-image: url("../assets/middle.png");
                background-size: 100% 100%;
                font-size: 0.45rem;
                font-family: HarmonyOS Sans SC-Medium, HarmonyOS Sans SC;
                font-weight: 500;
                color: #FFFFFF;
                letter-spacing: 3px;
            }

            .title_l,
            .title_r {
                height: 0.78rem;
                width: 7.75rem;
                display: flex;
                justify-content: space-between;
                padding-bottom: 0.24rem;

                .model {
                    display: flex;
                }

                .model_item {
                    // width: 1.7rem;
                    width: 1.4rem;
                    height: 0.52rem;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    // background-image: url("../assets/btn_bg_1.png");
                    background-image: url("../assets/new_bg_2.png");
                    background-size: 100% 100%;
                    font-size: 0.2rem;
                    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                    font-weight: 400;
                    color: #A3D8D6;
                    cursor: pointer;
                    margin-top: .1rem;

                }

                .current_nav_l {
                    // background-image: url("../assets/btn_bg_003.png");
                    background-image: url("../assets/new_bg_3.png");
                    font-size: 0.2rem;
                    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                    font-weight: 400;
                    color: #032929;
                }

                .current_nav {
                    // background-image: url("../assets/btn_bg_2.png") !important;
                    background-image: url("../assets/new_bg_4.png") !important;
                    font-size: 0.2rem;
                    font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                    font-weight: 400;
                    color: #032929;
                }
            }

            .title_l {
                background-image: url("../assets/left.png");
                background-size: 100% 100%;
                padding-right: .6rem;

                .goback {
                    // margin-top: 0.49rem;
                    display: flex;
                    align-items: center;
                }

                img {
                    width: 0.14rem;
                    height: 0.23rem;
                    margin-right: 0.1rem;
                    cursor: pointer;
                }

                span {
                    font-size: 0.18rem;
                    font-family: MicrosoftYaHei-, MicrosoftYaHei;
                    font-weight: normal;
                    color: rgba(0, 224, 219, 0.97);
                }
            }

            .title_r {
                background-image: url("../assets/right.png");
                background-size: 100% 100%;
                padding-left: .6rem;

                .time {
                    display: flex;
                    align-items: center;
                    padding-right: 0.11rem;
                }

                .time label {
                    font-size: 0.1rem;
                    font-family: MicrosoftYaHei-, MicrosoftYaHei;
                    font-weight: normal;
                    color: #2C75FD;
                    margin-top: 0.15rem;
                }

                .time span {
                    display: block;
                    font-size: 0.18rem;
                    font-family: MicrosoftYaHei-, MicrosoftYaHei;
                    font-weight: normal;
                    color: #FFFFFF;
                    margin-left: -0.75rem;
                    cursor: pointer;
                    margin-top: 0.2rem;
                }

                .model_item {
                    // background-image: url("../assets/btn_bg_004.png");
                    background-image: url("../assets/new_bg_1.png");
                }
            }
        }

        img {
            height: 0.45rem;
        }

    }
}
</style>